import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Container,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  styled
} from "@mui/material";
import VariantBox from "../components/variant-box";
import GradientBox from "../components/gradient-box";
import { useEffect, useState } from "react";
import { createApiCall } from "../api/api-service";
import { Link, useParams } from "react-router-dom";
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';

const GradientText = styled(Typography)(({ theme }) => ({
  background: `linear-gradient(60deg,${theme.palette.primary.main},${theme.palette.secondary.main})`,
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  
}));
const GradientButton = styled(IconButton)(({ theme }) => ({
  background: `linear-gradient(60deg,${theme.palette.primary.main},${theme.palette.secondary.main})`
  
}));


const ProductPage = () => {
  const { product } = useParams();
  const [productDetail, setProductDetail] = useState();
  const fetchProductData = async () => {
    const data = await createApiCall("POST", "inventory/fetch_product_info", {
      variant_id:product,
    });
    console.log("sdljfl",data);
    setProductDetail(data);
  };
  useEffect(() => {
    fetchProductData();
  }, [product]);
  if (productDetail === undefined) {
    return <>Loading .....</>;
  }

  return (
    <>
      <Container
        maxWidth={false}
        sx={{
          display: "flex",
          flexDirection: { xs:"column",ms:'row',lg:'row'},
          alignItems: "center",
          paddingTop: "10px",
        }}
      >
        <Box sx={{ width: {xs:"90%",ms:'90%',lg:'35%'}, height: "350px", borderRadius: "10px" }}>
          <img
            src={productDetail?.variant_image}
            width={"100%"}
            height={"100%"}
            style={{ borderRadius: "10px" }}
          />
        </Box>

        <Box sx={{ marginTop: "10px" }}>
          
          <Box sx={{ marginTop: "10px" }}>
            {/* Color Variant */}
            
            <Box sx={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
              {productDetail?.variant_info.map((variant, index) => {

                return (
                  <VariantBox
                    imgurl={variant?.variant_image}
                    variant_name={variant?.variant_name}
                    url={`/product/${variant?.variant_url}`}
                  />
                );
              })}
            </Box>
            {/* Product Title and color variant */}
          <Typography variant="h1" fontSize={"1.5rem"} fontWeight={'bold'} sx={{marginTop:'10px'}}>
            {productDetail?.variant_name}
          </Typography>
          <Typography variant="body2" sx={{color:'#11111199',marginTop:'10px'}}>{productDetail?.variant_desc.length >100 ? productDetail?.variant_desc.slice(0,100) + " Read More": productDetail?.variant_desc }</Typography>

            <Box marginTop={'10px'}>
              {/* price Component */}
             
              <Table>
                <TableBody>
                  {productDetail?.ecommerce_info.map((ecom, index) => {
                    return (
                      <TableRow sx={{ borderBottom: "1px solid" }}>
                        <TableCell variant="body" align="left" size="small"  >

                          <Typography variant="body2" fontWeight={'bold'} fontSize={'1rem'} gutterBottom>

                          {ecom.ecommerce_name.toUpperCase()}
                          </Typography>
                        </TableCell>
                        <TableCell variant="body" align="right" fontWeight={'bold'}  size="medium" >
                          <Link to={ecom?.affiliate_url} style={{textDecoration:'none'}} target="_blank">
                          <GradientText >
                          {ecom.ecommerce_price}
                          
                          <ArrowOutwardIcon sx={{color:'#F857A6'}} fontSize="medium"/> 
                          </GradientText>
                          </Link>
                        
                        </TableCell>
                      
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Box>
            {/* TODO: ADD Similar Product Box */}
            {/* <GradientBox header="Simmilar Product in other Brand">

                        </GradientBox> */}

            {/* <Accordion
              sx={{
                marginTop: "10px",
                maxHeight: "200px",
                overflowY: "scroll",
                scrollbarWidth: "none",
              }}
            >
              <AccordionSummary
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <Typography component="span">Product Details</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>{productDetail?.variant_desc}</Typography>
              </AccordionDetails>
            </Accordion> */}
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default ProductPage;
